import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SupportDesignModule } from 'src/Foundation/Design/app';
import { SharedModule } from 'src/shared';
import { BtpgFooterComponent } from './btpg-footer/btpg-footer.component';
import { BtpgShareComponent } from './btpg-share/btpg-share.component';
import { BtpgStepsCounterComponent } from './btpg-steps-counter/btpg-steps-counter.component';
import { BtpgWtuComponent } from './btpg-wtu/btpg-wtu.component';
import { BtpgSpotV2Controller } from './btpg-spot-v2/btpg-spot-v2.controller';
import { ShowOnVideoAvailabilityDirective } from './show-on-video-availability.directive';
var moduleId = 'gn.audio.support.btpg';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('BtpgSpotV2Controller', BtpgSpotV2Controller);
var BluetoothPairingGuideModule = (function () {
    function BluetoothPairingGuideModule() {
    }
    BluetoothPairingGuideModule = __decorate([
        NgModule({
            declarations: [
                BtpgFooterComponent,
                BtpgWtuComponent,
                BtpgShareComponent,
                BtpgStepsCounterComponent,
                ShowOnVideoAvailabilityDirective,
            ],
            id: moduleId,
            imports: [SupportDesignModule, legacyModuleId, SharedModule],
        })
    ], BluetoothPairingGuideModule);
    return BluetoothPairingGuideModule;
}());
export { BluetoothPairingGuideModule };
